import moment from 'moment'

const ExtendValidity = (params) => {

    let basestring = params.data.eway_bill_number;
    let encryptedstring = window.btoa(basestring);
    var urllink = '/extendewaybill/' + encryptedstring;
    if (params.data.eway_bill_status != "Cancelled") {
        if (params.data.eway_bill_valid_date != undefined && params.data.eway_bill_valid_date != '') {
            var validityDate = params.data.eway_bill_valid_date;
            var d1 = moment.parseZone(new Date()).format("YYYY-MM-DD HH:mm:ss")
            var d2 = moment.parseZone(new Date(validityDate)).utcOffset("+00:00").format("YYYY-MM-DD HH:mm:ss")
            var ms = moment(d2, "YYYY-MM-DD HH:mm:ss").diff(moment(d1, "YYYY-MM-DD HH:mm:ss"));
            var d = moment.duration(ms);
            var difference = parseFloat(d.asHours());
            if (difference <= 8 && difference >= -8) {
                return <a href={urllink} class="btn btn-success" style={{ padding: "0 6px 6px" }}>Extend</a>
            }
            else {
                return <button class="btn btn-success" style={{ padding: "0 6px 6px", color: "#ccc", cursor: "not-allowed" }} disabled>Extend</button>
            }
        }
        else {
            return <button class="btn btn-success" style={{ padding: "0 6px 6px", color: "#ccc", cursor: "not-allowed" }} disabled>Extend</button>
        }
    }
    else {
        return <button class="btn btn-success" style={{ padding: "0 6px 6px", color: "#ccc", cursor: "not-allowed" }} disabled>Extend</button>
    }
}
export default ExtendValidity